<template>
  <div class="orgBox">
    <a-tabs v-if="authority" :tab-bar-gutter="0" default-active-key="1">
      <a-tab-pane key="1" class="org-tab" tab="项目" >
        <a-tabs v-model="activeKey" :tab-bar-gutter="4" type="card" @change="changeTab">
          <!-- <a-tab-pane key="1" tab="合同项目">
            <contract-project ref="contractProject" />
          </a-tab-pane> -->
          <a-tab-pane key="2" tab="运营项目">
            <project-list ref="projectList"></project-list>
          </a-tab-pane>
        </a-tabs>
      </a-tab-pane>
      <a-tab-pane v-if="accountList && accountList.length > 0" key="2" tab="下级组织" >
        <subordinate></subordinate>
      </a-tab-pane>
    </a-tabs>
    <div v-else class="noAuthority">
      暂未对个人货主开放，敬请期待
    </div>
  </div>
</template>

<script>
import ProjectList from './ProjectList'
import Subordinate from './Subordinate';
// import ContractProject from './ContractProject'
import { getSubordinate } from './api'

export default {
  name: "Organization",
  components: {
    ProjectList,
    Subordinate,
    // ContractProject
  },
  props: {},
  data() {
    return {
      pageSize: 10,
      authority: true,
      accountData: {},
      accountList: [],
      activeKey: '2',
    };
  },
  computed: {},
  created() {
    this.authority = this.$store.state.user.companyType
    this.accountData = JSON.parse(localStorage.getItem('accountData'));
    this.getList()
  },
  mounted() {},
  methods: {
    changeTab() {
      let ref = 'contractProject'
      if (this.activeKey === '2') {
        ref = 'projectList'
      }
      if (this.$refs[ref]) {
        this.$refs[ref].reset()
      }
    },
    getList() {
      const data = {
        needCustomerInfo:true,
        type: 'ORG',
      }
      const {creditCode}=this.$store.state.user
      if(creditCode){
        data.creditCode=creditCode
      }else{
        data.parentId=this.accountData.id
      }
      const params = {
        size: 10,
        page: 1,
        sort: 'createTime__DESC',
      }
      getSubordinate(data, params).then((res) => {
        this.accountList = res.records
      })
    },
  },
};
</script>

<style lang="less" scoped>
.orgBox {
    box-sizing: border-box;
    ::v-deep .ant-tabs-line .ant-tabs-bar {
      padding: 0 24px;
      background: #fff;
      border-radius: 6px;
      margin-bottom: 20px;
      .ant-tabs-tab {
        padding: 0;
        height: 48px;
        line-height: 48px;
        width: 116px;
        width: 116px;
        text-align: center;
        color: #323232;
        font-weight: bold;
        font-size: 18px;
        &.ant-tabs-tab-active {
          color: #06B880;
        }
      }
      .ant-tabs-ink-bar {
        width: 84px !important;
        left: 16px;
      }
    }
}
.noAuthority{
  text-align: center;
  color: #ccc;
  height: calc(100vh - 200px);
  line-height: calc(100vh - 200px);
}
.org-tab {
  ::v-deep .ant-tabs-card {
    .ant-tabs-bar {
      padding: 0;
      background: none;
      .ant-tabs-nav-container {
        height: 48px;
        .ant-tabs-tab {
          background: #EBEDF0;
          border: none;
          color: #323232;
          width: 146px;
          font-weight: inherit;
          font-size: 14px;
          &.ant-tabs-tab-active {
            background: #fff;
            color: #06B880;
            font-weight: bold;
          }
        }
      }
    } 
    .ant-tabs-content {
      margin-top: -20px;
    }
  }
}
</style>